import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useModal } from "./chunk-R5DTDXZR.mjs";

// src/modal.tsx
import { Portal } from "@chakra-ui/portal";
import { createContext } from "@chakra-ui/react-context";
import { useMultiStyleConfig } from "@chakra-ui/system";
import { AnimatePresence } from "framer-motion";
import { jsx } from "react/jsx-runtime";
var _createContext = createContext({
    name: "ModalStylesContext",
    errorMessage: "useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Modal />\" "
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  ModalStylesProvider = _createContext2[0],
  useModalStyles = _createContext2[1];
var _createContext3 = createContext({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
  }),
  _createContext4 = _slicedToArray(_createContext3, 2),
  ModalContextProvider = _createContext4[0],
  useModalContext = _createContext4[1];
var Modal = function Modal(props) {
  var modalProps = _objectSpread({
    scrollBehavior: "outside",
    autoFocus: true,
    trapFocus: true,
    returnFocusOnClose: true,
    blockScrollOnMount: true,
    allowPinchZoom: false,
    motionPreset: "scale",
    lockFocusAcrossFrames: true
  }, props);
  var portalProps = modalProps.portalProps,
    children = modalProps.children,
    autoFocus = modalProps.autoFocus,
    trapFocus = modalProps.trapFocus,
    initialFocusRef = modalProps.initialFocusRef,
    finalFocusRef = modalProps.finalFocusRef,
    returnFocusOnClose = modalProps.returnFocusOnClose,
    blockScrollOnMount = modalProps.blockScrollOnMount,
    allowPinchZoom = modalProps.allowPinchZoom,
    preserveScrollBarGap = modalProps.preserveScrollBarGap,
    motionPreset = modalProps.motionPreset,
    lockFocusAcrossFrames = modalProps.lockFocusAcrossFrames,
    onCloseComplete = modalProps.onCloseComplete;
  var styles = useMultiStyleConfig("Modal", modalProps);
  var modal = useModal(modalProps);
  var context = _objectSpread(_objectSpread({}, modal), {}, {
    autoFocus: autoFocus,
    trapFocus: trapFocus,
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    returnFocusOnClose: returnFocusOnClose,
    blockScrollOnMount: blockScrollOnMount,
    allowPinchZoom: allowPinchZoom,
    preserveScrollBarGap: preserveScrollBarGap,
    motionPreset: motionPreset,
    lockFocusAcrossFrames: lockFocusAcrossFrames
  });
  return /* @__PURE__ */jsx(ModalContextProvider, {
    value: context,
    children: /* @__PURE__ */jsx(ModalStylesProvider, {
      value: styles,
      children: /* @__PURE__ */jsx(AnimatePresence, {
        onExitComplete: onCloseComplete,
        children: context.isOpen && /* @__PURE__ */jsx(Portal, _objectSpread(_objectSpread({}, portalProps), {}, {
          children: children
        }))
      })
    })
  });
};
Modal.displayName = "Modal";
export { useModalStyles, ModalContextProvider, useModalContext, Modal };